module.exports = __webpack_public_path__ + "img/secure-scalable.154198a1.png";